import React from 'react'

import type { SpaceProps } from '../../../../themes'
import { Container } from './styles'

export interface CardContentBodyProps extends SpaceProps {
  className?: string
  centered?: boolean
  children?: React.ReactNode
}

export const CardContentBody = ({
  className,
  centered,
  children,
  ...spaceProps
}: CardContentBodyProps) => (
  <Container className={className} centered={centered} {...spaceProps}>
    {children}
  </Container>
)
